import Button from "ds/components/Button";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import useTypedContext from "hooks/useTypedContext";
import FlashContext from "components/FlashMessages/FlashContext";
import { SEARCH_TOFU_WORKSPACES } from "shared/Stack/useSearchTofuWorkspaces/gql";
import useUnlockTofuWorkspace from "shared/Stack/useUnlockTofuWorkspace";
import { TofuWorkspace } from "types/generated";

const StackWorkspacesActionsCell = ({
  item: workspace,
  ...cellProps
}: TableSimpleCellProps<TofuWorkspace>) => {
  const { reportSuccess } = useTypedContext(FlashContext);
  const [unlockWorkspace, { loading }] = useUnlockTofuWorkspace({
    refetchQueries: [SEARCH_TOFU_WORKSPACES],
  });

  const handleUnlock = () => {
    unlockWorkspace({ id: workspace.id }, (data) => {
      if (data?.tofuWorkspaceUnlock) {
        reportSuccess({ message: `Workspace "${workspace.name}" unlocked successfully` });
      }
    });
  };

  if (!workspace.isLocked) {
    return <TableSimpleCell {...cellProps} />;
  }

  return (
    <TableSimpleCell {...cellProps}>
      <Button variant="secondary" size="small" onPress={handleUnlock} loading={loading}>
        Unlock
      </Button>
    </TableSimpleCell>
  );
};

export default StackWorkspacesActionsCell;
